import request from ".";

export const tendersApi = {
  getTenders: () => request.post(`Tenders/GetAllActiveTenders`),
  getActiveRfi: () => request.post(`Tenders/GetAllRFI`),
};
